export const CONFIRMATIONS = 'confirmations';
export const VIRTUAL = 'virtual';
export const AGENDA = 'agenda';
